<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Subject" @close="close()" />

      <v-card-text v-if="selectedCurriculum">
        <v-row>
          <v-col cols="12">
            <div class="text-body-1">
              Curriculum Name:
              <span class="font-weight-bold text-capitalize">
                {{ selectedCurriculum.name || "N/A" }}
              </span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="selectedSubject"
              dense
              autofocus
              hide-details
              :items="availableSubjects"
              clearable
              item-value="id"
              item-text="name"
              return-object
              label="Select Subject"
              outlined
            >
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title
                    class="text--primary text-capitalize"
                    v-text="item.name"
                  />
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
              v-model="marks"
              outlined
              type="number"
              dense
              label="Marks"
              min="0"
            />
          </v-col>

          <v-col cols="12" sm="2" class="d-flex align-center">
            <v-btn
              block
              color="success"
              @click="add"
              :disabled="!selectedSubject || !marks"
            >
              Add
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <div class="list-350">
          <draggable
            v-model="curriculumSubjectList"
            handle=".drag-handle"
            animation="150"
          >
            <div
              v-for="(row, index) in curriculumSubjectList"
              :key="row.id + '-' + index"
              class="d-flex align-center mb-2 pa-2 subject-row"
            >
              <v-icon class="mr-2 drag-handle" color="grey darken-1">
                mdi-drag
              </v-icon>

              <div class="flex-grow-1">
                <div class="text-capitalize font-weight-medium">
                  {{ index + 1 }}. {{ row.name }}
                </div>
              </div>

              <div style="width: 110px">
                <v-text-field
                  v-model="row.marks"
                  hide-details
                  outlined
                  type="number"
                  dense
                  label="Marks"
                />
              </div>

              <v-btn icon class="ml-2" @click="deleteRow(index)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </div>
          </draggable>

          <div v-if="!curriculumSubjectList.length" class="text-center grey--text py-4">
            No subjects added yet.
          </div>

          <div class="d-flex align-center justify-space-between mt-4 font-weight-bold">
            <div>
              Subject Count: {{ curriculumSubjectList.length }}
            </div>
            <div>
              Total Marks: {{ totalMarks }}
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import curriculumService from "@/modules/ReportCard/Curriculums/service.js";
import subjectService from "@/modules/ReportCard/Subject/service.js";
import draggable from "vuedraggable";

export default {
  name: "Assign-Class-to-student",
  props: {
    editDialog: {
      default: false,
    },
    selectedCurriculum: {
      type: Object,
      default: null,
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      Subjects: [],
      selectedSubject: null,
      marks: null,
      curriculumSubjectList: [],
      loading: false,
      dialog: false,
    };
  },
  computed: {
    totalMarks() {
      return this.curriculumSubjectList.reduce((total, row) => {
        return total + (parseInt(row.marks) || 0);
      }, 0);
    },

    availableSubjects() {
      const assignedIds = this.curriculumSubjectList.map((row) => row.id);
      return this.Subjects.filter((subject) => !assignedIds.includes(subject.id));
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },

    dialog(val) {
      if (val) {
        this.getSubject();

        if (
          this.selectedCurriculum &&
          this.selectedCurriculum.subjectMeta &&
          this.selectedCurriculum.subjectMeta.subjects
        ) {
          this.curriculumSubjectList = JSON.parse(
            JSON.stringify(this.selectedCurriculum.subjectMeta.subjects)
          );
        } else {
          this.curriculumSubjectList = [];
        }

        console.log(
          "selectedCurriculum in assign subject",
          this.selectedCurriculum
        );
      }
    },
  },
  methods: {
    deleteRow(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.curriculumSubjectList.splice(i, 1);
        }
      });
    },

    add() {
      if (!this.selectedSubject || !this.marks) return;

      const obj = {
        id: this.selectedSubject.id,
        marks: parseInt(this.marks) || 0,
        name: this.selectedSubject.name,
      };

      this.curriculumSubjectList.push(obj);
      this.selectedSubject = null;
      this.marks = null;
    },

    getSubject() {
      return subjectService.getAll().then((response) => {
        this.Subjects = response.data || [];
        console.log("response Subjects", this.Subjects);
        return response;
      });
    },

    submit() {
      if (this.totalMarks !== 100) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Total marks should be equal to 100",
          });
        return true;
      }

      this.loading = true;

      this.curriculumSubjectList = this.curriculumSubjectList.map((row, idx) => ({
        ...row,
        order: idx + 1,
        marks: parseInt(row.marks) || 0,
      }));

      const payload = {
        ...this.selectedCurriculum,
        subjectMeta: {
          subjects: this.curriculumSubjectList,
        },
      };

      curriculumService
        .update(this.selectedCurriculum.id, payload)
        .then((result) => {
          if (result) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Subjects assigned to this curriculum",
              });

            this.loading = false;
            this.empty();
            this.$emit("submit");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },

    close() {
      this.$emit("close");
      this.empty();
    },

    empty() {
      this.selectedSubject = null;
      this.marks = null;
      this.curriculumSubjectList = [];
    },
  },
};
</script>

<style scoped>
.subject-row {
  border: 1px solid #eee;
  border-radius: 10px;
  background: white;
}

.drag-handle {
  cursor: grab;
}
</style>